export default __webpack_public_path__ + "static/media/downarrow.06c47ea2.svg";